export function formatDeviceHeading(value: number): string {
  return value.toFixed(1);
}
